import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";

// Componets
import AssessmentHeader from "./AssessmentHeader.js";
import AssessmentInRecruitment from "./AssessmentInRecruitment.js";
import AssessmentInfoBlocks from "./AssessmentInfoBlocks.js";
import AssessmentMatch from "./AssessmentMatch.js";
import CertificationBlock from "./certificationBlock.js";
import LinkedinBlock from "../Homepage/LinkedinBlock.js";

const StyledAssessment = styled(NanoFlex)`
  height: auto;
  padding: 0 50px 0px 50px;
  gap: 124px;

  .linkedinBlock {
    flex-direction: row-reverse;

    .leftContentBlock,
    .rightContentBlock {
      width: 50%;
    }

    .leftContentBlock {
      padding: 0 0 0 80px;

      .button {
        width: 100%;

        button {
          justify-content: center;
          width: 100%;
        }
      }
    }

    .rightContentBlock {
      padding: 0;

      .consultantsSliding {
        &::before {
          right: -17vw;
          left: unset;
        }
      }

      .consultantName {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 1450px) {
  }

  @media only screen and (max-width: 1024px) {
    .linkedinBlock {
      .leftContentBlock,
      .rightContentBlock {
      }

      .rightContentBlock {
        .consultantsSliding {
          &::before {
            right: -5vw;
          }
        }
      }

      .leftContentBlock {
        padding: 0 32px;
        align-items: center;
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0px 30px 0px 30px;
    gap: 84px;

    .linkedinBlock {
      .leftContentBlock {
        padding: 0 10px;
        align-items: center;
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .linkedinBlock {
      .leftContentBlock {
        width: 100%;
      }
    }
  }
`;

export default class Assessment extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAssessment flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} data-aos="fade-up" data-aos-duration="1500">
        <AssessmentHeader />
        <AssessmentInRecruitment />
        <AssessmentInfoBlocks />
        <AssessmentMatch />
        <CertificationBlock />
        <LinkedinBlock />
      </StyledAssessment>
    );
  }
}
